import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../common';
import queryString from 'query-string';

export const API_ENDPOINT = 'geonames';
export const SUBURBS_ENDPOINT = `${API_ENDPOINT}/search/suburbs`;

const actions = createActions({
  GEONAMES: {
    API: {
      SUBURBS: {
        GET: apiResourceActionCreator('suburbs')
      }
    },
    SUBURBS: {
      GET: (query) => ({ query })
    }
  }
});

export const apiActions = {
  geonames: {
    suburbs: {
      get: (authToken, query) => commonApiActions.authenticated.get(`${SUBURBS_ENDPOINT}?${queryString.stringify(query)}`, authToken, actions.geonames.api.suburbs.get)
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/geonames/actions.js